<template>
    <div class="theme-changer">
        <v-switch
            v-model="theme"
            label="Classic Theme"
            class="theme-changer-switch"
            @click="theme ? changeTheme(themes[1].id) : changeTheme(themes[0].id)"
        ></v-switch>
        <!-- <v-menu bottom origin="center center" transition="scale-transition" class="theme-changer-menu">
            <template #activator="{ on, attrs }">
                <v-fab-transition>
                    <v-btn color="primary" fab dark small v-bind="attrs" class="theme-changer-menu-toggler" v-on="on">
                        <v-icon>mdi-brush</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <v-list dense class="theme-changer-menu-list">
                <v-subheader>Themes</v-subheader>
                <v-list-item-group v-model="current" color="primary">
                    <v-list-item
                        v-for="(theme, index) in themes"
                        :key="index"
                        class="theme-changer-menu-list-item"
                        @click="changeTheme(theme.id)"
                    >
                        <v-list-item-title class="theme-changer-menu-list-item-copy">{{
                            theme.name
                        }}</v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-menu> -->
    </div>
</template>
<script>
export default {
    name: 'ThemeChanger',
    data() {
        return {
            themes: this.$root._data.themes,
            current: this.currentTheme,
            theme: false,
        };
    },
    computed: {
        currentTheme() {
            return this.$store.state.themes.current;
        },
    },
    watch: {
        currentTheme(newTheme) {
            this.theme = !newTheme.id === this.themes.find((t) => t.default).id;
        },
    },
    created() {},
    methods: {
        changeTheme(themeId) {
            return this.$store.dispatch('themes/setCurrentTheme', themeId);
        },
    },
};
</script>
